import { Moment } from 'moment';
import { QuestResponseType } from '../Quotation/Quotation.types';

export enum SalesByCstReportType {
  analytical = 'Analytical',
  synthetic = 'Synthetic',
  perPart = 'PerPart',
  perInvoice = 'PerInvoice',
}

export interface QuestReportSalesByCstRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  reportType: SalesByCstReportType;
  cstPisCofins?: string;
  startDate: string;
  endDate: string;
  cfopIdsToInhibit?: string;
}

export interface QuestSalesByCstFormValues {
  reportType: SalesByCstReportType;
  cstPisCofins?: string[];
  companiesIds?: number[];
  cfopIdsToInhibit?: number[];
  initialDate: Moment;
  finalDate: Moment;
}
